

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import actualidadModule from '@/store/actualidad'
import formulariosModule from '@/store/formularios'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';

import appinfo from '../../package.json';


export const store = new Vuex.Store({
  state :{
    language: localStorage.getItem('language') || 'es',
    packageVersion : appinfo.version,
    igfeed : ''
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
      });
    },
    initApp: ({commit,dispatch}) => {
      
      dispatch('requestCategorias')
    },
    requestIGFeed : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {

				axios.get('https://api.instagram.com/v1/users/self/media/recent?access_token=30409849.1677ed0.10098a1fdf454ababdd4a6863211d55a')
					.then(response => {
						commit('setIGfeed', response.data.data);
						resolve(true);
					})
					.catch(error => reject(error));

			});
    },
  },
  getters : {
    getVersion : state => state.packageVersion,
    getLanguage : state => state.language,
    getIGFeed : state => state.igfeed,
    getTexts : state => {
      return messages[state.language];
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    },
    setIGfeed(state,data){
      state.igfeed = data
    }
  },
  modules :{
    actualidadModule,
    formulariosModule,
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js